//Configure a topWindow variable to point
//to the top window only if it is accessible
//given CORS requirements

var topLocation
var topWindow;

try {
    if (typeof top == "object" && typeof window == "object") {
        topLocation = top.document
        topWindow = window.top
    
        if (!topWindow || !topWindow.navigator) topWindow = window
    } else if(typeof window == "object") {
        topWindow = window
    }
} catch(error) {
    topWindow = window
}

if (topWindow && !topWindow.appCode && topWindow.schemeId) {
    topWindow.appCode = topWindow.schemeId
}

var storage

if (typeof window == "object") {
    var Radical = window.Radical || {}
    if (!topWindow) topWindow = window
    if (!topWindow || !topWindow.navigator) topWindow = window

    if (window.storage) {
        storage = window.storage.default
    }

    if (!storage && typeof localStorage == "object") {
        storage
    }
}


function deviceFactory (EventEmitter, Promise, _, storage, getApiAddress, delay, window, schemeSettings, appStats, http, getParameterByName, context) {
    context = context || {}
    var schemeId = null

    if (context.schemeId) {
        schemeId = context.schemeId
    } else if (topWindow && topWindow.schemeId) {
        schemeId = topWindow.schemeId
    }

    if (!schemeSettings) {
        schemeSettings = { globals: {}}
    }

    if (typeof getParameterByName != "function") {
        var getParameterByName = function () {
        }
    }

    if (typeof appName == "undefined") {
        var appName = schemeId
    }

    if (window && window.addEventListener) {
        window.addEventListener('message', function (event) {
            if (event.data.unlock) {
                that.unlock(event.data.unlock.code, event.data.unlock.packet)
            }
        })
    }
    
    var indexBy = _.indexBy || _.keyBy

    function getLocations() {
        return api('getLocations', {
            schemeId: schemeId,
            uid: Device.thrid
        }).then(function(results) {
            Device.locations = results.results.locations
            Device.locationLookup = indexBy(results.results.locations, 'id')
        })
    }

    storage = storage || localStorage

    function getItem(key, value) {
        try {
            return storage.getItem(key) || value
        } catch (e) {
            return value
        }
    }

    //Wrap local storage to trap for private mode
    function setItem(key, value) {
        try {
            return storage.setItem(key, value) || value
        } catch (e) {

        }
    }

    function radicalNoop() {
        console.log("No Operation")
    }

    var empty = {}
    var groups = {}

    function invokeParams(array, refThis, b) {
        if (!array || array.$processing) {
            return
        }

        array.$processing = true

        var i, l
        var parameters = empty
        if (b) {
            parameters = Array.prototype.slice.call(arguments, 2)
        }
        
        var toTrigger = array.slice()

        for (i = 0, l = toTrigger.length; i < l; i++) {
            try {
                toTrigger[i].apply(refThis, parameters)
            }
            catch (e) {
                console.error(e.stack)
            }
        }
        array.$processing = false
    }

    function invoke(array, refThis) {
        if (!array) {
            return;
        }

        for (var i = array.length - 1; i >= 0; i--) {
            array[i].apply(refThis);
        }
    }

    function guid() {
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x'
                ? r
                : (r & 0x3 | 0x8)
            return v.toString(16).toUpperCase()
        })
    }

    var globals = typeof Radical != "undefined" && Radical.radicalGlobals !== false
    if (globals) {
        console.log("Configure globals")

        if (typeof topWindow == "object" && window) {
            window.console = topWindow.console
            topWindow.setId = topWindow.setId || radicalNoop
            window.navigator.geolocation = topWindow.navigator.geolocation
            topWindow.badgeCount = topWindow.badgeCount || radicalNoop
        }
        
        if (window) {
            window.$$services = {
                gtp: 3001,
                api: 3000,
                gtps: 3040,
                apis: 3009
            }
        }
    }
    var sessionId = guid()

    var isCDNLocal = typeof window == "object" && window && window.cdnPath && (_.startsWith(window.location.href,
            window.cdnPath) || _.startsWith(window.location.href, window.cdnOverride))

    var apiAddress = null

    var events = {}

    function trigger(name, parameters) {
        try {
            that.emit(name, parameters);
            var list = events[name] || []
            var params = Array.prototype.slice.call(arguments, 1)
            params.unshift(that)
            params.unshift(list)
            invokeParams.apply(that, params)
        }
        catch (e) {
            console.error(e.stack)
        }
    }

    var statusList = []
    var infoList = []
    var idList = []
    var hasStatus = false
    var hasInfo = false
    var hasId = false

    function resolveMessage(message) {
        if (_.isObject(message)) {
            return message
        }
        return (that.info.messages.filter(function (m) {
            return m.systemId == message
        }) || [null])[0]
    }

    function pushIfNeeded(array, fn) {
        if (array.indexOf(fn) == -1) {
            array.push(fn)
        }
    }//

    var lastProcessedBy = {}

    function makeProcessedByChangeDetector(name) {
        return function (xhr) {
            if (xhr && typeof xhr.getResponseHeader == "function") {
                var processedBy = (xhr.getResponseHeader("x-processed-by") || xhr.getResponseHeader("x-processed-id"))

                if (!processedBy) {
                    return
                }

                if (!lastProcessedBy[name]) {
                    lastProcessedBy[name] = processedBy
                    return
                }

                if (lastProcessedBy[name] != processedBy) {
                    lastProcessedBy[name] = processedBy
                    if (typeof appStats == "object" && appStats) {
                        appStats.inc(["web", "processedBy", "change", "sha256:isM59YQn30RYzv2usI+/DX/+YD2GlXACsu6eCxJ3qMU="], 1, { tags : { service : name } })
                    }
                }
            }
        }
    }

    function makeRequestSizeReporter(name) {
        return function (xhr) {
            if (xhr && typeof appStats == "object" && appStats) {
                if ((this || {}).url) {
                    appStats.hist(["web", "request", "hist", "urlLength", "sha256:I4f7HR2xuRsD83RH/lkBnGiwnJzyRpoqgxU5fQHKGUM="], this.url.length, { tags : { service : name } })
                }

                if ((this || {}).hasContent) {
                    appStats.hist(["web", "request", "hist", "bodySize", "sha256:gu+Xp7ikRjjUazT4gjonws1XblYvWQzlRQKZY1oLGNs="], this.data.length, { tags : { service : name } })
                }

                if (xhr.responseText) {
                    appStats.hist(["web", "response", "hist", "bodySize", "sha256:uyzQ0AhSPeZBOuvNLV0hX61NPkfYkBA/MDopTW+iExQ="], xhr.responseText.length, { tags : { service : name } })
                }
            }
        }
    }

    function makeRequestTimerReporter(name) {
        var timer = null

        if (typeof appStats == "object" && appStats) {
            timer = appStats.timer()
        }

        return function (xhr) {
            if (timer) {
                timer.mark(["web", "response", "time", "sha256:HGpYMlpHgwNtRsnGqfhGtlzpc63Vzinh0LcL5vPl3tw="], { tags : { service : name } })
            }
        }
    }

    function makeRequestErrorReporter(name) {
        return function (xhr) {
            if (xhr && xhr.status && xhr.status >= 400 && typeof appStats == "object" && appStats) {
                appStats.inc(["web", "request", "error", "sha256:KfKTmGHHEEJMvVnTI9myF3BHkrA9OqB/P2XMY8tI7DM="], { tags : { status : xhr.status.toString().substr(0,1), service : name } })
            }
        }
    }

    function remove(array, fn) {
        var idx = array.indexOf(fn)
        if (idx != -1) {
            array.splice(idx, 1)
        }
    }

    function api(command, options, verb) {
        _.merge(options, {cacheKill: Date.now()})
        return http({
            url: getApiAddress({
                port: 3030,
                path: 'api/' + command
            }),
            data: options,
            headers : { "x-3r-route" : that.thrid },
            type: verb || 'get',
            dataType: 'json',
            complete: [
                makeProcessedByChangeDetector("api"),
                makeRequestSizeReporter("api"),
                makeRequestTimerReporter("api"),
                makeRequestErrorReporter("api")
            ]
        })
    }

    var gtpResultList = []

    function processUnlockResults(result) {
        var infoOrNot = null
        if (shouldRefreshInfo(result)) {
            infoOrNot = getInfo()
        } else {
            infoOrNot = Promise.resolve(true)
        }
        
        return infoOrNot.then(function (){
            trigger('unlock', result.hasOwnProperty('response') ? result : _.extend({}, result, {response: result}))
        }).then(function () {
            return result
        })
    }

    function gtp(command, options, verb) {
        var retries = 0
        options = options || {}
        _.merge(options,
            {
                cacheKill: Date.now(),
                schemeId: schemeId
            })
        options.uid = Device.thrid
        command = command.replace(/:([a-zA-Z0-9_]+)/ig, function (match, capture) {
            var value = encodeURIComponent(options[capture])
            delete options[capture]
            return value || ""
        })
        return http({
            url: getApiAddress({
                port: 3040,
                path: command
            }),
            data: options,
            type: verb || 'get',
            timeout: 30000,
            headers : { "x-3r-route" : that.thrid },
            complete: [
                makeProcessedByChangeDetector("gtp"),
                makeRequestSizeReporter("gtp"),
                makeRequestTimerReporter("gtp"),
                makeRequestErrorReporter("gtp")
            ]
        }).then(function (results) {
            if (typeof results == 'string') {
                try {
                    results = JSON.parse(results)
                } catch (e) {

                }
            }
            if (typeof results == 'object')
                trigger('gtp', results)
            return results
        })
    }

    var device = context.deviceId

    if (typeof topWindow == "object") {
        device = topWindow.deviceId
    }

    if (!device && getParameterByName('deviceId')) {
        device = getParameterByName('deviceId')
    }

    if (!device && getItem('device-id')) {
        device = getItem('device-id')
    }
    
    /* Regenerate DeviceID if it doesn't look valid */

    if (!device || (device || "").length < 16) {
        device = guid()
    }

    if (typeof window == "object" && window) {
        if (!window.skipDevicePrefix && device.indexOf('| |') == -1) {
            device = schemeId + "| |" + (getParameterByName('application') ? getParameterByName('application') + ":" : "") + device
        }
    }

    try {
        if (globals && typeof window == "object" && window) {
            window.deviceId = device
        }
        setItem('device-id', device)

    }
    catch (e) {

    }

    function getHiddenProp() {
        var prefixes = ['webkit', 'moz', 'ms', 'o'];

        if (typeof document == "undefined") {
            return null
        }

        // if 'hidden' is natively supported just return it
        if ('hidden' in document) return 'hidden';

        // otherwise loop over all the known prefixes until we find one
        for (var i = 0; i < prefixes.length; i++) {
            if ((prefixes[i] + 'Hidden') in document) {
                return prefixes[i] + 'Hidden';
            }
        }

        // otherwise it's not supported
        return null;
    }

    function isHidden() {
        var prop = getHiddenProp()
        if (!prop) return false
        return document[prop]
    }

    var visProp = getHiddenProp();
    if (visProp) {
        var evtname = visProp.replace(/[H|h]idden/, '') + 'visibilitychange';
        document.addEventListener(evtname, function visibilityChange() {
            trigger('visibility', isHidden())
            if (isHidden()) {
                trigger('hidden')
            } else {
                trigger('shown')
            }
        });
    }

    function register() {
        /****************************************************************************
         * window.noRegisterDev is defined in MP - schemeSettings.globals.noRegisterDev
         * It's needed when the webframework is embedded in client's app,
         * client will do the registerDev and pass the guid to webframework
         ****************************************************************************/
        if (window && window.noRegisterDev == "yes") {
            var guid = getParameterByName("guid")
            console.log("00 mark: skip register() and use the guid passed from URL by client: " + guid)
            return processWithUid(guid)
        }
        else {
            console.log("00 mark: window.noRegisterDev is not defined")
        }

        function processWithUid(uid) {
            statsLoadingMark(["device", "web", "processWithUid", "sha256:2AgfEi5g98AsqHW7eyNFUggY4QHbWz4S1ilcnDXQ/TQ="])
            if (window) {
                window.thrid = uid
            }
            
            if ((topWindow || window) && (topWindow || window).setId) {
                (topWindow || window).setId(uid)
            }
            
            that.thrid = uid
            getLocations()
            storage.setItem('thrid', that.thrid)
            invokeParams(idList, that, uid)

            if (!context.disableInfoAutoUpdate) {
                setInterval(function () {
                    if (that.paused) {
                        return
                    }
                    getInfo()
                }, 1000 * 60)
            }

            var firstInfo = getInfo()

            firstInfo.then(function () {
                statsLoadingMark(["device", "web", "firstInfo", "sha256:u8Aybh5/2Van358Cb35SkiuHNFQFRaJjIjULSr90WTg="])
            })

            return firstInfo
        }

        var startReq = {
            mode: 'start',
            duid: device,
            uid: that.thrid,
            app: appName,
            referrer: getParameterByName('referrer'),
            schemeId: schemeId
        }

        return api('registerDev', startReq)
            .then(function (data) {
                if (data.requestStatus.failureCode) {
                    if([111,400].indexOf(data.requestStatus.failureCode) > -1 && data.requestStatus.failureMessage.indexOf('Invalid UID') > -1) {
                        return that.forget()
                    }
                    setTimeout(register, 1000)
                    return
                }

                var infoPromise = processWithUid(data.results.uid)
                trigger('registered', data.results)
                return infoPromise
            }).catch(function (e) {
                console.log(e, e.stack)
                if (window && window.Offline && window.Offline.state == 'down') {
                    function registerOnUp() {
                        Offline.off('up', registerOnUp)
                    }

                    Offline.on('up', registerOnUp)
                } else {
                    setTimeout(register, 1000)
                }
            })
    }

    var lastMessageDate

    if (typeof navigator == "undefined") {
        var isiPad = false
    } else {
        var isiPad = navigator.userAgent.match(/iPad/i) != null && top != window
    }

    var currentGetInfo
    var queuedGetInfo
    var failedUserInfo = 0
    var lookup = {}

    var campaigns = {} //JSON.parse(storage.getItem('campaigns') || '{}')
    var messages = {}//JSON.parse(storage.getItem('messages') || '{}')
    var progressions = {}
    var developer = getParameterByName('developer')
    var tester = getParameterByName('tester')
    var app = getParameterByName('app')
    var appAddress = getParameterByName('useapi')
    var radicalRealmsSupport = getParameterByName('radicalrealms')
    var lastCampaignTime = 0


    function evaluateInContext(expression, suppliedData) {
        expression = expression.replace(/&nbsp;/ig, " ").replace(/`|‘|’/g, "'")
        return function () {
            try {
                var user = that.info.user
                var uid = Device.thrid
                var messages = that.info.messages
                var profile = ((that.info.user.data.variables || {}).public || {}).profile || {}
                var extra = suppliedData
                return eval(expression)
            } catch (e) {
                console.error("Error with expression", expression, e)
            }
        }()
    }

    function getInfo() {

        if (queuedGetInfo) {
            return queuedGetInfo
        }

        if (currentGetInfo) {
            if (!queuedGetInfo) {
                queuedGetInfo = Promise.resolve(currentGetInfo)
                    .catch(function (){ return null})
                    .then(function () {
                        return realGetInfo()
                    })
            }
            return queuedGetInfo
        }
        
        return realGetInfo()
    }
    
    function realGetInfo() {
        "use strict"
        var results
        if (Date.now() - lastCampaignTime > 1000 * 60 * 10) {
            campaigns = {}
            lastCampaignTime = Date.now()
        }
        
        if (!that.thrid) {
            return Promise.reject(new Error("Device not registered."))
        }
        var currentInfo = Promise.resolve(null).then(function () {
            console.log('getInfo')

            var getInfoTimer = statsTimer()

            return currentGetInfo = api('get', {
                uid: that.thrid,
                schemeId: schemeId,
                service: radicalRealmsSupport ? 1 : undefined
            }).then(function (info) {
                results = info.results

                getInfoTimer.mark(["device", "web", "getInfo", "gotHistory", "sha256:gXzzlmbkna629xkiytVv8mHh6XhHGBfshEBf9IsI45c="])

                var missing = _(results.messages)
                    .uniq('cid')
                    .map(function (m) {
                        return campaigns[m.cid]
                            ? null
                            : m.cid
                    })
                    .filter(function (m) {
                        return m
                    })
                    .value()

                if (missing.length) {
                    return api('getCampaigns',
                        {
                            uid: that.thrid,
                            campaigns: JSON.stringify(missing)
                        })
                        .then(function (response) {
                            _.forEach(response.results, function (r) {
                                campaigns[r.Id] = r
                            })
                            // storage.setItem('campaigns', JSON.stringify(campaigns))

                            getInfoTimer.mark(["device", "web", "getInfo", "gotCampaigns", "sha256:RcrpEYSd6sR/MfFT6mKOZJ/CHAPjz6mKOKSwXcsRTDQ="])
                        })

                }
            }).then(function () {
                var missing = _(campaigns)
                    .map(function (m) {
                        return m
                    })
                    .uniq('messageId')
                    .map(function (m) {
                        return messages[m.messageId]
                            ? null
                            : m.messageId
                    })
                    .filter(function (m) {
                        return m
                    })
                    .value()
                if (missing.length) {
                    return api('getMessages',
                        {
                            uid: that.thrid,
                            messages: JSON.stringify(missing)
                        })
                        .then(function (response) {
                            _.forEach(response.results, function (r) {
                                messages[r.id] = r
                            })
                            try {
                                storage.setItem('messages', JSON.stringify(messages))
                            }
                            catch (e) {

                            }

                            getInfoTimer.mark(["device", "web", "getInfo", "gotMessages", "sha256:EBhpBVkGcnlko1Tq6xMFWCoCIyoQjPVV6sKkvIoZSK8="])
                        })
                }
            }).then(function () {
                    var toProcess = _(results.messages)
                        .filter(function (message) {
                            return campaigns[message.cid].quantities.unlockablesToCount
                        })
                        .map(function (message) {
                            return campaigns[message.cid].quantities.unlockablesToCount.split(',').map(function (code) {
                                return {message: message, code: code.trim()}
                            })
                        })
                        .flatten()
                        .map(function (code) {
                            return gtp('count/:code', {code: code.code})
                                .then(function (result) {
                                    return {message: code.message, error: result.count==0 || result.error, count : result.count, max : result.max }
                                })
                        }).value()
                    return Promise.all(toProcess).then(function (response) {
                        _(response)
                            .map(function (code) {
                                /* Handle availability increasing */
                                if (code.message.codeCountRemaining) {
                                    delete code.message.codeCountRemaining
                                }

                                if (code.message.codeCountMax) {
                                    delete code.message.codeCountMax
                                }

                                return code
                            })
                            .forEach(function(code) {
                                var remaining = false
                                if (code.error) {
                                    code.message.notAvailable = true
                                    remaining = 0
                                } else if (code.max) { //If max is 0 no limit is applied.
                                    remaining = code.count || 0

                                    if (typeof code.message.codeCountMax == "number") {
                                        code.message.codeCountMax = Math.min(code.message.codeCountMax, code.max)
                                    } else {
                                        code.message.codeCountMax = code.max
                                    }
                                }

                                if (typeof remaining == "number") {
                                    if (typeof code.message.codeCountRemaining == "number") {
                                        code.message.codeCountRemaining = Math.min(code.message.codeCountRemaining, remaining)
                                    } else {
                                        code.message.codeCountRemaining = remaining
                                    }
                                }
                            })

                        getInfoTimer.mark(["device", "web", "getInfo", "counts", "sha256:1fgzdZ8lSI2DfjRstac0lrskQ24nzrGNKV3MxBHRgWg="])
                   })
            }).then(function () {


                if (!results.user) {
                    console.log("No User")
                    statsInc(["device", "web", "failedUserInfo", "sha256:I+40M4QiBQX84QFXGl83wf0MiJbaU7k1jh0JnY9v434="])

                    failedUserInfo = failedUserInfo + 1

                    if (failedUserInfo >= 5) {
                        Device.forget()
                    } else {
                        return new Promise(function (accept, reject) {
                            setTimeout(function() {
                                return accept(getInfo())
                            }, 1000)
                        })
                    }
                    return
                } else {
                    failedUserInfo = 0
                }
                results.user.progress = results.user.progress || {}
                results.user.progress.progressions = results.user.progress.progressions || {}
                var missing = _.filter(results.user.progress.progressions, function (p) {
                    return p && !progressions[p.id]
                })
                return Promise.all(missing.map(function (m) {
                    return gtp('/progress/definition/:id', {
                        id: m.id
                    }).then(function (response) {
                        progressions[m.id] = response
                        return response
                    }).catch(function (e) {
                         console.warn("Exception whilst getting progress definition", e)
                         return false
                    })
                }))
            }).then(function () {

                getInfoTimer.mark(["device", "web", "getInfo", "progress", "sha256:MwD8z2XtZ6BPYFEXo6P7vRK6Hh45lVpL1eOY612ZRLQ="])

                that.info = results
                if (results.user) {
                    _.forEach(_.filter(results.user.progress.progressions, function (p) {
                        return p
                    }), function (p) {
                        p.definition = progressions[p.id]
                    })
                }

                that.info.messages = _(results.messages).filter(function (f) {
                    return f && campaigns[f.cid] && messages[campaigns[f.cid].messageId] && !f.notAvailable
                }).map(function (m) {
                    if (!m.notAvailable && !m.codeCountMax) {
                        m.codeCountNotLimited = true
                    }

                    return m
                }).map(function (m) {
                    return _.extend({
                        ATTRIBUTES: _.extend({},
                            m,
                            {
                                messageClassName: campaigns[m.cid].className,
                                validFrom: campaigns[m.cid].validFrom,
                                validTo: campaigns[m.cid].validTo
                            })
                    }, messages[campaigns[m.cid].messageId], campaigns[m.cid])
                }).value()
                lookup = {}
                that.info.messages.forEach(function (m) {
                    lookup[m.ATTRIBUTES.id] = m
                    m.categories = {}
                    _.forEach(m.category.toLowerCase().split(' '), function (cat) {
                        m.categories[cat] = true
                    })
                })
                
                that.batchReceived(that.info.messages)
                
                that.info.messages = _(that.info.messages)
                    .filter(function (message) {
                        if (!message) return false
                        if (message.categories['development'] && !developer) return false
                        if (message.categories['testing'] && !tester) return false

                        if ((message.quantities || {}).userDataUnlock && message.quantities.userDataUnlock.expression) {
                            try {
                                return evaluateInContext(message.quantities.userDataUnlock.expression)
                            } catch (e) {
                                console.warn("Exception whilst evaluating expression", e)
                                return false
                            }
                        }
                        return true
                    }).value()

                //fix all wrong image path with duplicate suffixes such as ".jpg.jpg", ".JPG.jpg", ".png.jpg" etc
                function fixImgPath(path){
                    if(path.charAt(path.length - 1 - 3) == "." && (path.charAt(path.length - 1 - 7) == "." || path.charAt(path.length - 1 - 8) == ".")){
                        return path.substr(0, path.length - 1 - 3)
                    }else{
                        return path
                    }
                }

                that.info.messages.forEach(function(m, index){
                    m.heroImage = fixImgPath(m.heroImage)
                    m.offerImage = fixImgPath(m.offerImage)
                })

                that.permanentId =
                    that.info.user && that.info.user.data
                        ? that.info.user.data.permanentId
                        : (window || {}).thrid

                hasInfo = !!that.info;
                
                if (topWindow || window) {
                    (topWindow || window).$info = that.info;
                }

                if(typeof parent != "undefined" && parent) {
                    parent.postMessage({type: 'info', info: that.info}, '*')
                }
                try {
                    storage.setItem('getinfo', JSON.stringify(that.info))
                }
                catch (e) {

                }
                
                if (queuedGetInfo) {
                    currentGetInfo = queuedGetInfo
                    queuedGetInfo = null
                } else {
                    currentGetInfo = null
                }
                
                updateInfo()
                getInfoTimer.mark(["device", "web", "getInfo", "finally", "sha256:PcUyeSyDMmPJs5GYK84wgHWp9R9jFM52Yfao/leIUuQ="])
                return that.info
            }).catch(function (error) {
                console.error(error, error.stack)
                getInfoTimer.mark(["device", "web", "getInfo", "error", "sha256:0ur/Nq/lpXwlZRRpvm2LK48CXC8hd+Hqim9ocjcnOX4="])
            })
        })
        
        return currentInfo
    }

    function updateVariables() {
        storage.setItem('getinfo', JSON.stringify(that.info))
        setTimeout(function () {
            trigger('variables', that.variables)
        })
    }

    var updateInfo = _.debounce(function () {
        hasInfo = !!that.info
        if (hasInfo) {
            trigger('info', that.info)
            trigger('messages', that.info.messages)
            trigger('user', that.info.user)
            //trigger('locations', that.info.locations)
            invokeParams(infoList, that, that.info)
        }
    })

    var currentData = Promise.resolve()
    var codes = []
    var unlockPromise
    var unlockRequest
    var unlockDelay = context.unlockDelay
    
    if (typeof unlockDelay != "number") {
        unlockDelay = 20
    }
    
    var sendCodes = function () {
        if (unlockPromise) {
            return unlockPromise
        }
        
        unlockPromise = delay(unlockDelay)
            .then(function () {
                return unlockRequest
            })
            .then(function (){
                var codesToSend = codes.splice(0, codes.length) 
                unlockPromise = null

                // TODO: Remove the following debugging log
                if(!that.thrid || that.thrid == undefined || that.thrid == 'undefined') {
                    console.warn('unlockmultiple called with values missing')
                    console.warn(' that.thrid is', that.thrid, ' and codesToSend were ', JSON.stringify(codesToSend || {}, null, 2))
                }
                
                var gtpResult = gtp('unlockmultiple/' + appName + '/' + that.thrid + '?cacheKill=' + Date.now(), {
                    waitForLock : context.unlockWaitForLock || false,
                    codes: codesToSend
                }, "POST")
                
                unlockRequest = gtpResult
                    .catch(function (e) {
                        var queuedUnlocks = codesToSend.filter(function (code) { return code.queued})
                        
                        if (queuedUnlocks.length) {
                            Array.prototype.splice.apply(codes,[0, 0].concat(queuedUnlocks))
                        }
                        
                        return false
                    })
                    .then(function(val){
                        unlockRequest = null
                        return val ? true : false
                    })
                
                return gtpResult
            })
            .then(processUnlockResults)
        
        return unlockPromise 
    }
    
    var startTime = Date.now();
    var heartBeatCount = 0;
    var heartBeatList = [1, 1, 1, 2, 2, 3, 3, 3, 5, 7, 10, 15, 20, 100, 1000, 5000]
    var heartBeatPos = 0
    //15 second heartbeat pulse to the server


    function debugLog(msg){
        if(top.schemeSettings.globals.enableLoadingDebug){
            console.log(msg)
        }
    }

    var isPaused = context.paused

    if (isPaused && _.get(schemeSettings, "globals.unpauseDevice")) {
        isPaused = false
    }

    var thatProps = {
        paused : isPaused,
        api: api,
        gtp: gtp,
        debugLog: debugLog,
        canUpdateData: function (fn) {
            var currentInfo = currentGetInfo || Promise.resolve(null)
            
            if (!fn) {
                return currentInfo.then(function () {
                    return currentData
                })
            }
            
            //Storing currentData operation in a buffer variable
            var activeData = currentData

            //Queues currentData after currentInfo resolves, and reassigns the result to itself
            currentData = currentInfo.then(function () {
                return activeData.catch(function(e){
                    console.warn("Device.canUpdateData Failure: ", e)
                }).then(function () {
                    return Promise.resolve(fn())
                })
            })

            return currentData
        },
        updateVariables: function () {
            that.variables = that.variables //update
        },
        getApiAddress: getApiAddress,
        updateThrid: function (thrid, stayPaused) {
            if (that.paused && !stayPaused) {
                that.paused = false
            }
            
            if (window && window.thrid != thrid) {
                window.thrid = thrid
            }

            if(that.thrid == thrid) return
            that.thrid = thrid
            
            storage.setItem('thrid', thrid)
            
            if ((topWindow || window) && (topWindow || window).setId) {
                (topWindow || window).setId(thrid)
            }
            
            try {
                that.info.messages = []
                updateInfo()
                getLocations()
            } catch(e) {

            }
            trigger('thrid', thrid)
            if(typeof parent != "undefined" && parent) {
                parent.postMessage({
                    type: 'userinfo',
                    schemeId: schemeId,
                    thrid: thrid
                }, '*')
            }
        },
        read: function (message, extra) {
            var status
            message = resolveMessage(message)
            if (!message) return
            extra = extra || {}
            switch (status = message.ATTRIBUTES.status.toLowerCase()) {
                case 'read':
                case 'redeemed':
                    trigger('reread', message)
                    break
                default:
                    if (status == 'sent' || status == 'received') {
                        that.unlock('WM.ReadFirstTime', message.systemId, message.ATTRIBUTES.origin)
                    }
                    message.ATTRIBUTES.status = 'read'
                    updateInfo()
                    return api('messageAction', _.merge(extra, {
                        action: 'read',
                        uid: that.thrid,
                        className: message.ATTRIBUTES.messageClassName,
                        msgId: message.ATTRIBUTES.id
                    })).then(function () {
                        message.ATTRIBUTES.status = 'read'
                        updateInfo()
                        trigger('read', message)
                    }).then(function () {
                        return that.unlock('WM.Read', message.systemId, message.ATTRIBUTES.origin)
                    })

                    return Promise.resolve("ok")
            }
        },
        batchRead: function(messages, extra){
            let batchMessages = [], batchCodes = []
            extra = extra || {}
            
            _.forEach(messages, function(message) {
                var status
                message = resolveMessage(message)
                if (!message) return
                switch (status = message.ATTRIBUTES.status.toLowerCase()) {
                    case 'read':
                    case 'redeemed':
                        trigger('reread', message)
                        break
                    default:
                        if (status == 'sent' || status == 'received') {
                            batchCodes.push({
                                code: 'WM.ReadFirstTime', 
                                packet: message.systemId, 
                                origin: message.ATTRIBUTES.origin
                            })
                        }
                        
                        message.ATTRIBUTES.status = 'read'
                        
                        batchMessages.push(_.merge(_.clone(extra), {
                            className: message.ATTRIBUTES.messageClassName,
                            msgId: message.ATTRIBUTES.id
                        }))
                }
            })
            
            updateInfo()
            
            if(batchMessages.length > 0){
                return api('messagesBatchAction', { 
                    action: 'read', 
                    uid: that.thrid,
                    messages: batchMessages
                }).then(function () {
                    _.forEach(messages, function(message){
                        //Double Tapping message status update, behaviour picked from original read() function, presumably due to overwriting & persistence issue on the message objects
                        message.ATTRIBUTES.status = 'read'
                        batchCodes.push({
                            code: 'WM.Read', 
                            packet: message.systemId, 
                            origin: message.ATTRIBUTES.origin
                        })
                        trigger('read', message)
                    })
                    
                    updateInfo()
                }).then(function () {
                    return that.batchUnlock(batchCodes)
                })
            } else {
                //FUTURE WORK: Correct Promise.resolve() call position in original read() function definition, should be moved outside/after of switch case statement to cover for promise resolution in read/redeemed status cases
                return Promise.resolve("ok")
            }
        },
        received: function (message, extra) {
            message = resolveMessage(message)
            extra = extra || {}
            switch (message.ATTRIBUTES.status.toLowerCase()) {
                case 'read':
                case 'redeemed':
                case 'received':
                    break
                default:
                    if ((schemeSettings).globals.receivedProcessing == 'no') {
                        message.ATTRIBUTES.status = 'received'
                    } else {
                        return api('messageAction', _.merge(extra, {
                            action: 'received',
                            uid: that.thrid,
                            className: message.ATTRIBUTES.messageClassName,
                            msgId: message.ATTRIBUTES.id
                        })).then(function () {
                            message.ATTRIBUTES.status = 'received'
                            trigger('received', message)
                        }).then(function () {
                            return that.unlock('WM.Received', message.systemId, message.ATTRIBUTES.origin)
                        })
                    }

            }

            return Promise.resolve("ok")
        },
        batchReceived: function(messages, extra){
            let batchMessages = []
            extra = extra || {}
            
            _.forEach(messages, function(message){
              message = resolveMessage(message)
              switch (message.ATTRIBUTES.status.toLowerCase()) {
                case 'read':
                case 'redeemed':
                case 'received':
                    break
                default:
                    if ((schemeSettings).globals.receivedProcessing == 'no') {
                        message.ATTRIBUTES.status = 'received'
                    } else {
                        batchMessages.push(_.merge(_.clone(extra), {
                            className: message.ATTRIBUTES.messageClassName,
                            msgId: message.ATTRIBUTES.id
                        }))
                    }
                }
            })
            
            if(batchMessages.length > 0){
                let batchCodes = []
                return api('messagesBatchAction', { 
                    action: 'received', 
                    uid: that.thrid,
                    messages: batchMessages
                }).then(function () {
                    _.forEach(messages, function(message){
                        message = resolveMessage(message)
                        message.ATTRIBUTES.status = 'received'
                        batchCodes.push({
                            code: 'WM.Received', 
                            packet: message.systemId, 
                            origin: message.ATTRIBUTES.origin
                        })
                        trigger('received', message)
                    })
                }).then(function () {
                    return that.batchUnlock(batchCodes)
                })
            } else {
                return Promise.resolve("ok")
            }
        },
        redeemed: function (message, extra) {
            var status;
            message = resolveMessage(message)
            extra = extra || {}
            switch (status = message.ATTRIBUTES.status.toLowerCase()) {
                default:
                    message.ATTRIBUTES.status = 'redeemed'
                    updateInfo()
                    return api('messageAction', _.merge(extra, {
                        action: 'redeemed',
                        uid: that.thrid,
                        className: message.ATTRIBUTES.messageClassName,
                        msgId: message.ATTRIBUTES.id
                    })).then(function () {
                        message.ATTRIBUTES.status = 'redeemed'
                        getInfo()
                        trigger('redeemed', message)
                    }).then(function () {
                        return that.unlock('WM.Redeemed', message.systemId, message.ATTRIBUTES.origin)
                            .then(function () {
                                if (status == 'read') {
                                    return that.unlock('WM.RedeemedFirstTime', message.systemId, message.ATTRIBUTES.origin)
                                }
                            })
                    })

                    break
            }
        },
        batchRedeemed: function(messages, extra){
            let batchMessages = [], batchCodes = []
            extra = extra || {}
            
            _.forEach(messages, function(message) {
                var status;
                message = resolveMessage(message)
                
                switch (status = message.ATTRIBUTES.status.toLowerCase()) {
                    default:
                        message.ATTRIBUTES.status = 'redeemed'
                        
                        batchMessages.push(_.merge(_.clone(extra), {
                            className: message.ATTRIBUTES.messageClassName,
                            msgId: message.ATTRIBUTES.id
                        }))
                        
                        if (status == 'read') {
                            batchCodes.push({
                                code: 'WM.RedeemedFirstTime', 
                                packet: message.systemId, 
                                origin: message.ATTRIBUTES.origin
                            })
                        }
                }
            })
            
            updateInfo()
            
            if(batchMessages.length > 0){
                return api('messagesBatchAction', { 
                    action: 'redeemed', 
                    uid: that.thrid,
                    messages: batchMessages
                }).then(function () {
                    _.forEach(messages, function(message){
                        //Double Tapping message status update, behaviour picked from original read() function, presumably due to overwriting & persistence issue on the message objects
                        message.ATTRIBUTES.status = 'redeemed'
                        batchCodes.push({
                            code: 'WM.Redeemed', 
                            packet: message.systemId, 
                            origin: message.ATTRIBUTES.origin
                        })
                        trigger('redeemed', message)
                    })
                    
                    getInfo()
                }).then(function () {
                    return that.batchUnlock(batchCodes)
                })
            } else {
                return Promise.resolve("ok")
            }
        },
        status: function (fn) {
            pushIfNeeded(statusList, fn)
            if (hasStatus) {
                fn(that.status)
            }
            return fn
        },
        messages: function (fn) {
            pushIfNeeded(infoList, fn)
            if (hasInfo) {
                fn(that.info)
            }
            return fn
        },
        newId: function (fn) {
            pushIfNeeded(idList, fn)
            if (hasId) {
                fn(that.thrid)
            }
            return fn
        },
        id: function (fn) {
            if (hasId) {
                fn(that.thrid)
                return
            }
            var f = function (id) {
                fn(id)
                that.remove(f)
            }
            pushIfNeeded(idList, f)
            return f
        },
        setDeviceId: function (newDeviceId) {
            if (window && !window.skipDevicePrefix && newDeviceId.indexOf('| |') == -1) {
                newDeviceId = schemeId + "| |" + (getParameterByName('application') ? getParameterByName('application') + ":" : "") + newDeviceId
            }
            that.deviceId = device = newDeviceId
            
            if (window) {
                window.device = newDeviceId
            }
            
            try {
                setItem('device-id', device)
            }
            catch (e) {

            }
            return register()
        },
        remove: function (fn) {
            remove(statusList, fn)
            remove(infoList, fn)
            remove(idList, fn)
        },
        referralCode: function (appAddress, source) {
            var parts = appAddress.split('?')
            var values = _.filter((parts.length > 1
                ? parts[1]
                : '').split('&'), function (d) {
                return d && !d.match(/(source|referrer)=/ig)
            })
            values.push('referrer=' + that.info.user.ATTRIBUTES.publicId)
            if(source) values.push("source=" + source)
            return parts[0] + '?' + values.join('&')
        },
        acknowledge: function (idOrMessage) {
            var id = idOrMessage.id || idOrMessage
            return gtp('ack/:thrid/:id', {
                thrid: Device.thrid,
                id: id
            })
        },
        getInfo: getInfo,
        getInfoVersion: function (version) {
            switch (version) {
                case 0:
                    that.getInfo = oldgetInfo
                    break
                default:
                    that.getInfo = getInfo
                    break
            }
        },
        gotInfo: function (fn) {
            if (that.info) {
                fn(that.info)
                return
            }
            var f = function (info) {
                fn(info)
                setTimeout(function () {
                    that.remove(f)
                })
            }
            pushIfNeeded(infoList, f)
            return f
        },
        queueUnlock: function (code, packet, origin) {
            var unlockable

            codes.push(unlockable = {
                code: code,
                packet: JSON.stringify(packet),
                origin: origin || sessionId,
                queued : true,
                ts : Date.now()
            })
            trigger('unlock', unlockable)
        },
        unlock: function (code, packet, origin) {
            return currentData
                .catch(function () {
                    return null
                })
                .then(function () {
                    var unlockable
                    codes.push(unlockable = {
                        code: code,
                        packet: JSON.stringify(packet),
                        origin: origin || sessionId,
                        ts : Date.now()
                    })
                    trigger('unlock', unlockable)
                    return sendCodes().then(function (fromSend) {
                        return fromSend
                    })
                })
        },
        batchUnlock: function(batchCodes){
            if(!Array.isArray(batchCodes)){
                return Promise.reject(new Error("Batch Unlock argument should be an array"))
            }
            
            if(batchCodes.length < 1){
                return Promise.resolve("ok")
            }
            
            _.forEach(batchCodes.slice(0, -1), function(code){
                that.queueUnlock(code.code, code.packet, code.origin)
            })

            let code = batchCodes.slice(-1)[0]
            return that.unlock(code.code, code.packet, code.origin)
        },
        privateData: function (data) {
            return gtp('data/' + that.thrid + '/' + schemeId, {
                data: JSON.stringify(data),
                private: true
            })
        },
        data: function (data) {
            return currentData = gtp('data/' + that.thrid,{ data : data }, 'POST')
                .then(function (result) {
                    updateVariables()
                })
        },
        forget: function () {
            statsInc(["device", "web", "forget", "sha256:39lLFqUZSGqneLjBBDzxizsQX69CVvOBsSs0uY/nmxM="])

            that.extraLogouts.forEach(function(fn) {
                fn()
            })
            if (typeof topWindow == "object" && topWindow && topWindow.isRadicalApp) {
                that.api('registerDev', {mode: 'logout', publicId: that.info.user.ATTRIBUTES.publicId})
                storage.removeItem('getinfo')
                setTimeout(function () {
                    topWindow.location.reload()
                }, 2000)
            } else {
                var regenerateDeviceId = !_.get(typeof schemeSettings == "object" ? schemeSettings : {}, "globals.doNotRegenerateDeviceId", false)
                var newId = null

                if (regenerateDeviceId) {
                    newId = guid() + ":" + schemeId
                    if(typeof parent == "object") {
                        parent.postMessage({forget: true, duid: newId}, "*")
                    }
                    setItem('device-id', newId)
                }

                storage.removeItem('getinfo')
                storage.removeItem('thrid')

                if(!context.skipRedirect && window){
                    setTimeout(function () {
                        var loc = ((typeof topWindow == "object" ? topWindow : window).location.search||"").split('&').map(function(o) {
                            var parts = o.split('=')
                            if(!o) {
                                return o
                            }
                           
                            if(parts[0] && parts[0][0] == '?') {
                                parts[0] = parts[0].slice(1)
                            }
                            if(regenerateDeviceId && parts[0] == 'deviceId') {
                                parts[1] = encodeURIComponent(newId)
                            }
                            if(parts[0] == 'token') {
                                parts[0] = 'oldtoken'
                            }
                            return parts[0] + "=" + parts[1]
                        }).join('&')
                        var chosenWindow = typeof topWindow == "object" ? topWindow : window
                        var urlBefore = chosenWindow.location.href 
                        var urlAfter = chosenWindow.location.href.replace(/#.*/,'').split('?')[0] + "?" + loc

                        chosenWindow.location.href = urlAfter
                        if(urlBefore == urlAfter) {
                            chosenWindow.location.reload()
                        }
                    }, 520)
                }
            }
        },
        getMessage: function (id) {
            return lookup[id]
        },
        schemeId: schemeId,
        apiAddress: apiAddress,
        processUnlockResults: processUnlockResults,
        evaluateInContext: evaluateInContext,
        shouldRefreshInfo: shouldRefreshInfo,
        extraLogouts: [],
        resolveMessage : resolveMessage
    }
    
    var that = Object.create(EventEmitter.prototype)
    for (var k in thatProps) {
        if (thatProps.hasOwnProperty(k)) {
            that[k] = thatProps[k]
        }
    }
    EventEmitter.call(that)
    
    that.trigger = that.emit
    
    if (typeof Device == "undefined") {
        var Device = that
    }

    var info = storage.getItem('getinfo')
    var thrid = storage.getItem('thrid')

    if(!thrid){
        info = null
    }

    if (thrid) {
        function setThridAndRegister() {
            that.updateThrid(thrid)
            var registerPromise = register()

            registerPromise.then(function() {
                that.unlock('WEB.started', sessionId)
                statsLoadingMark(["device", "web", "started", "sha256:/Fcd3vK1uhT3oIQBBYhHafezpspraDseCwMrS8FvziU="])
            })

            return registerPromise
        }

        if (context.instantRegister) {
            that.registration = setThridAndRegister()
        } else {
            that.registration = new Promise(function (accept, reject) {
                setTimeout(function () {
                    setThridAndRegister()
                        .then(function (info) {
                            accept(info)
                            return info
                        })
                        .catch(function (e) {
                            return reject(e)
                        })

                },10)
            })
        }
    }

    if (info) {

        function setInfoAndUpdate() {
            that.info = JSON.parse(info)
            lookup = {}
            that.info.messages.forEach(function (m) {
                lookup[m.ATTRIBUTES.id] = m
            })
            that.permanentId =
                that.info.user && that.info.user.data
                    ? that.info.user.data.permanentId
                    : (window || {}).thrid

            hasInfo = !!that.info;
            
            if (topWindow || window) {
                (topWindow || window).$info = that.info;
            }

            updateInfo()
        }

        if (context.instantRegister) {
            setInfoAndUpdate()
        } else {
            setTimeout(setInfoAndUpdate.bind(this), 10)
        }
    }
    that.serveLocal = getParameterByName("local")
    that.deviceId = device
    that.gtpAddress = apiAddress + ':3040'
    that.isMobile = {
        Android: function () {
            return navigator.userAgent.match(/Android/i)
        },
        BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i)
        },
        iOS: function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i)
        },
        Opera: function () {
            return navigator.userAgent.match(/Opera Mini/i)
        },
        Windows: function () {
            return navigator.userAgent.match(/IEMobile/i)
        },
        any: function () {
            return (Device.isMobile.Android() || Device.isMobile.BlackBerry() || Device.isMobile.iOS() || Device.isMobile.Opera() || Device.isMobile.Windows())
        }
    }

    that.destroy = function () {
        delete that.info.messages
        delete that.info.user
        delete that.info
    }

    function mergeReplaceArray(a, b) {
        if (_.isArray(a) || _.isArray(b)) return b
    }

    function mergeWithCustomizerWrapper(obj, sources, customizerFct){
        if(_.mergeWith && typeof _.mergeWith === 'function'){
            _.mergeWith(obj, sources, customizerFct)
        } else {
            _.merge(obj, sources, customizerFct)
        }
    }

    Object.defineProperties(that, {
        hidden: {
            get: function () {
                return isHidden()
            }
        },
        variables: {
            get: function () {
                return that.info && that.info.user
                    ? that.info.user.data.variables
                    : {}
            },
            set: function (value) {
                (currentGetInfo || Promise.resolve(null))
                    .catch(function () {})
                    .then(function () {
                        mergeWithCustomizerWrapper(that.info.user.data.variables, value, mergeReplaceArray)
                        return that.data(value).then(function (d) {
                            mergeWithCustomizerWrapper(that.info.user.data.variables, d, mergeReplaceArray)
                        })
                    })

                mergeWithCustomizerWrapper(that.info.user.data.variables, value, mergeReplaceArray)
                updateVariables()
            }
        },
        private: {
            get: function () {
                {
                }
            },
            set: function (value) {
                (currentGetInfo || Promise.resolve(null))
                    .catch(function () {})
                    .then(function () {
                        that.privateData(value);
                    })
            }
        },
        hasInfo: {
            get: function () {
                return hasInfo
            }
        },
        innerWidth: {
            get: function () {
                return isiPad
                    ? 610
                    : window.innerWidth
            }
        },
        innerHeight: {
            get: function () {
                return isiPad
                    ? 510
                    : window.innerHeight
            }
        },
        allMessages: {
            get: function () {
                if (!that.info) {
                    return []
                }
                return that.info.messages
            }
        },
        evaluateInContext: evaluateInContext,
        shouldRefreshInfo: shouldRefreshInfo
    })

    function shouldRefreshInfo(data) {
        var lastRefresh

        if(!data) {
            return false
        }

        var thisRefresh = data.refresh || (data.response || {}).refresh


        if(typeof thisRefresh == 'number' && thisRefresh > 0) {
            lastRefresh = storage.getItem('lastRefresh')
            storage.setItem('lastRefresh', thisRefresh)
            return !lastRefresh || lastRefresh < thisRefresh
        } else {
            return thisRefresh
        }
    }

    if (globals) {
        window.picturePath = getApiAddress({
            port: 80,
            cdn: true,
            path: 'uploaded_pictures/'
        })
        window.serverLocations = {
            gtp: getApiAddress({port: 3040}) + "/",
            api: getApiAddress({port: 3030}) + "/",
            appCode: schemeId,
            secure: getApiAddress({port: 3040}) + "/",
            app: getApiAddress({port: 3020}),
            getInfo: getApiAddress({
                port: 3030,
                path: "api/getInfo"
            }),
            getSpendables: getApiAddress({
                port: 3030,
                path: "api/getSpendables"
            }),
            qrScan: getApiAddress({
                port: 3040,
                path: "qr"
            }),
            uploader: getApiAddress({
                port: 3040,
                path: "upload"
            }),
            unlockables: getApiAddress({
                port: 3040,
                path: "unlock/"
            }),
            unlockableCount: getApiAddress({
                port: 3040,
                path: "count/"
            }),
            unlockableMap: getApiAddress({
                port: 3030,
                path: "map/"
            })
        }

        window.rootPath = ''
        topWindow.unlock = window.unlock = function (code, packet) {
            // DPB-217
            // Change over to the Device.gtp service rather than $.ajax:
            return gtp('unlock/:schemeId/:code/:id?cacheKill=:cacheKill', 
                {
                    code: code, 
                    id: getId(), 
                    packet : packet
                }
                ,"POST")
        }
        window.currentGameInfo = {}

        window.showFrame = function (frm) {
            console.log(frm)
        }

        window.getId = function () {
            return Device.thrid
        }

    }


    //Trigger a get info when the page is reshown
    
    if (window) {
        window.addEventListener("shown", function () {
            if (that.thrid) {
                that.getInfo()
            }
        })
    }

    if (typeof Radical == "object" && Radical.useOldStyleGetInfo) {
        that.getInfoVersion = 0
    }
    
    if (!thrid) {
        that.registration = new Promise(function (accept, reject) {
            setTimeout(function () {
                if (that.paused) {
                    return accept()
                }

                register()
                    .then(function (info) {
                        that.unlock('WEB.started', sessionId)
                        statsLoadingMark(["device", "web", "started", "sha256:/Fcd3vK1uhT3oIQBBYhHafezpspraDseCwMrS8FvziU="])

                        return accept(info)
                    })
                    .catch(function (e) {
                        return reject(e)
                    })
            }, 10)
        })
    }

    that.registration.then(function () {
        if (!context.disableInfoAutoUpdate) {
            setInterval(function () {
                heartBeatCount++
                if (heartBeatCount >= heartBeatList[heartBeatPos]) {
                    that.queueUnlock('WEB.Heartbeat', Math.floor((Date.now() - startTime) / 1000))
                    heartBeatCount = 0
                    heartBeatPos = Math.min(heartBeatPos + 1, heartBeatList.length - 1)
                }
            }, 20000)
        }
    })

    function statsInc(metric, value, tags) {
        if (typeof appStats == "object" && appStats) {
            appStats.inc(metric, typeof value == "number" ? value : 1 , { tags : (tags || {}) })
        }
    }

    function statsLoadingMark(metric, value, tags) {
        if (typeof appStats == "object" && appStats && appStats.loading && appStats.loading.mark) {
            appStats.loading.mark(metric, typeof value == "number" ? value : 1 , { tags : (tags || {}) })
        }
    }

    function statsTimer() {
        if (typeof appStats == "object" && appStats && appStats.timer) {
            return appStats.timer()
        } else {
            return { mark : function () {} }
        }
    }

    return that
}

deviceFactory._depends = {
    symbol : "3r/device-api/device/deviceFactory",
    global : "deviceFactory",
    modules : [
        "EventEmitter",
        "Promise",
        "_",
        "3r/storage",
        "3r/getApiAddress",
        "3r/delay",
        {
            symbol : "window",
            nullIfMissing : true
        },
        {
            symbol : "3r/schemeSettings/webapp",
            nullIfMissing : true
        },
        {
            symbol : "3r/webframework/appStats",
            nullIfMissing : true
        },
        "3r/device-api/device/http",
        {
            symbol : "3r/getParameterByName",
            nullIfMissing : true
        }
    ]
}

function http($, Q, request){
    return Q($.ajax(request))
}

http._depends = {
    symbol : "3r/device-api/device/http",
    modules : [
        "jQuery",
        "Q"
    ]
}

if (typeof exports == "object") {
    exports.deviceFactory = deviceFactory
    exports.http = http
}

if (typeof window == "object" && window == this && this.ioc && typeof this.ioc.inject == "function") {
    this.ioc.inject(http)
    window.deviceFactory = deviceFactory = this.ioc.inject(deviceFactory)
}
